import { render } from "./FaireTest.vue?vue&type=template&id=f330d832&scoped=true&ts=true"
import script from "./FaireTest.vue?vue&type=script&lang=ts"
export * from "./FaireTest.vue?vue&type=script&lang=ts"

import "./FaireTest.vue?vue&type=style&index=0&id=f330d832&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f330d832"]])

export default __exports__